import { useEffect, useState } from 'react';

const usePrimaryNavScrollCollapse = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    let platformScreen = null;

    const checkAndBindScroll = () => {
      platformScreen = document.querySelector('div.screen-scroll');
      if (platformScreen) {
        const handleScroll = () => {
          const hasOverflow = platformScreen.scrollTop > 0;
          setIsCollapsed(hasOverflow);
        };

        platformScreen.addEventListener('scroll', handleScroll); // Check on scroll
        handleScroll(); // Check immediately when the div mounts

        return () => {
          platformScreen.removeEventListener('scroll', handleScroll);
        };
      }
    };

    const observer = new MutationObserver(() => {
      checkAndBindScroll(); // Bind to the element once it appears
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      if (platformScreen) {
        platformScreen.removeEventListener('scroll', checkAndBindScroll);
      }
      observer.disconnect();
    };
  }, []);

  return isCollapsed;
};

export default usePrimaryNavScrollCollapse;
